<div class="dialog-container">
    <div mat-dialog-title>Attention</div>
    <span class="close-button" (click)="submit(null)">&times;</span>

    <mat-dialog-content>
        <div class="modal-text"><span>Are you on a call with a client?</span></div>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
        <button mat-raised-button color="secondary" (click)="submit(false)">No</button>
        <button mat-raised-button color="primary" (click)="submit(true)">Yes</button>
    </mat-dialog-actions>
</div>